/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

// Query string and URL functions for navigation within app. (Separate functions are used to build JSON requests.)
// Use alternative to query-string module because it is incompatible with create-react-app
// See https://github.com/sindresorhus/query-string/pull/148

export function parseQueryString(queryString) {
    const query = {};
    const queryStringWithoutQMark = (queryString[0] === '?') ? queryString.substr(1) : queryString;
    const pairs = queryStringWithoutQMark.split('&');
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}

export function generateQueryString(params) {
    const queryStrings = [];
    Object.keys(params).forEach((prop) => {
        const encodedProp = encodeURIComponent(prop);
        const encodedValue = encodeURIComponent(params[prop]);
        queryStrings.push(encodedProp + '=' + encodedValue);
    });

    if (queryStrings.length) {
        return '?' + queryStrings.join('&');
    }

    return null;
}
